import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useApi } from 'stores/api';

const ConfirmRegistration = (props) => {
    const { t } = useTranslation(['registration-confirm']);
    const api = useApi();

    const qsp = new URLSearchParams(document.location.search);
    const userId = qsp.get("userId") || '';
    const token = qsp.get("token") || '';

    const [regnConfirmed, setRegnConfirmed] = useState(false);

    useEffect(() => {
        async function confirmUser() {
            let result = await api.confirmUserEmail(userId, encodeURIComponent(token));
            if (result) {
                setRegnConfirmed(true);
            }
        }

        if (userId && token) {
            confirmUser(userId, token);
        }
    }, []);

    return (
        <>
            {regnConfirmed && <section className="profile-container">
                <div className="wrapper">
                    <div className="row profile-content">
                        <div className="column-12">
                            <h3 className="mali-blue margin-bottom">{t("regnCompleteTitle")}</h3>
                        </div>
                    </div>
                    <div className="row registersSuccess-content">
                        <div className="column-6 offset-3">
                            <div className="registersSuccess-container">
                                <p>{t("regnCompleteSubtitle")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row registersSuccessBtns-container">
                        <div className="column-6 offset-3">
                            <Link className="forward" to="/">
                                {t("regnCompleteGoHome")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    )
}

export default ConfirmRegistration;